export enum UnitSystemType {
  METRIC = 'METRIC',
  IMPERIAL = 'IMPERIAL',
}

